// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QOhai","col":"styles_col__2OuaM","actions":"styles_actions__8S7Ky","conflict":"styles_conflict__2w2T_"};